import { render } from "./Partner.vue?vue&type=template&id=153b1e2e&scoped=true&ts=true"
import script from "./Partner.vue?vue&type=script&lang=ts"
export * from "./Partner.vue?vue&type=script&lang=ts"

import "./Partner.vue?vue&type=style&index=0&id=153b1e2e&lang=scss&scoped=true"

import exportComponent from "E:\\vueapp\\xm-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153b1e2e"]])

export default __exports__